import { process, State } from "@progress/kendo-data-query"
import { Grid, GridColumn, GridColumnMenuCheckboxFilter } from "@progress/kendo-react-grid"
import { Tooltip } from "@progress/kendo-react-tooltip"
import { MDBBreadcrumb, MDBBreadcrumbItem } from "mdbreact"
import { useEffect, useState } from "react"
import AlertToastr from "../../components/Shared/alertToastr"
import AddEditUser from "../../components/User/AddEdit"
import { RootState } from "../../rootReducer"
import { columnProps } from "../../shared/ActiveGridFilter"
import { SpinnerGrid } from "../../shared/CommonItems"
import { useAppDispatch, useAppSelector } from "../../store"
import {
    checkUserExists,
    fetchAppUsers,
    fetchUsers,
    getSelectedUserDetails,
    getUserRole,
    toggleAddEditUserModal,
} from "./userSlice"

const initialState: State = { sort: [{ field: "firstName", dir: "asc" }], skip: 0, take: 100 }
const AppUsers = () => {
    const dispatch = useAppDispatch()

    const users = useAppSelector((state: RootState) => state.containers.users.users)
    const loading = useAppSelector((state: RootState) => state.containers.users.usersLoading)
    var appUsers = useAppSelector((state: RootState) => state.containers.users.appUsers)

    const [dataState, setDataState] = useState(initialState)

    useEffect(() => {
        dispatch(fetchUsers())
        dispatch(fetchAppUsers())
    }, [dispatch])

    useEffect(() => {
        setDataState(initialState)
    }, [users])

    const toggleEditUserModal = (e: any, props: any, flag: boolean) => {
        e.preventDefault()
        const { appUserId } = props
        dispatch(checkUserExists(appUserId))
        dispatch(getUserRole(appUserId))
        dispatch(getSelectedUserDetails(appUserId))

        dispatch(toggleAddEditUserModal(flag))
    }

    const EmailLinkCell = (props: any) => (
        <td
            style={{
                textDecoration: "underline",
                cursor: "pointer",
            }}
            colSpan={props.colSpan}
            role={"gridcell"}
            aria-colindex={props.ariaColumnIndex}
        >
            <a href=" " onClick={event => toggleEditUserModal(event, props.dataItem, true)}>
                {props.dataItem.emailAddress}
            </a>
        </td>
    )

    const StatusIconCell = (props: any) => {
        const { appUserId, appUserRoleId } = props.dataItem
        return (
            <td
                colSpan={props.colSpan}
                role={"gridcell"}
                aria-colindex={props.ariaColumnIndex}
            >
                {appUsers.some(x => x.appUserID === appUserId) ?
                    appUsers.some(x => x.appUserRoleId === appUserRoleId && x.appUserID === appUserId) ? (
                        ""
                    ) : (
                        <Tooltip openDelay={100} position="bottom" anchorElement="pointer"><i title="Role changed, please review to update user settings" className="fas fa-exclamation-circle text-warning">
                        </i>
                        </Tooltip>
                    )
                    : (
                        <Tooltip openDelay={100} position="bottom" anchorElement="pointer"><i title="Please review to activate this new user" className="fas fa-exclamation-circle text-danger"></i></Tooltip>
                    )
                }

            </td>
        )
    }

    const AppRoleCell = (props: any) => (
        <td colSpan={props.colSpan} role={"gridcell"} aria-colindex={props.ariaColumnIndex}>
            {props.dataItem.appRole}
        </td>
    )

    return (
        <>
            <MDBBreadcrumb>
                <MDBBreadcrumbItem> Administration </MDBBreadcrumbItem>
                <MDBBreadcrumbItem active>Users</MDBBreadcrumbItem>
            </MDBBreadcrumb>

            <AlertToastr />
            <div className="position-relative">
                {loading && <SpinnerGrid />}
                <Grid
                    style={{
                        height: "calc(100vh - 10.3rem)",
                    }}
                    data={process(users, dataState)}
                    {...dataState}
                    sortable
                    pageable
                    onDataStateChange={e => setDataState(e.dataState)}
                >   <GridColumn
                        width={"40px"}
                        cell={props => <StatusIconCell {...props} />}
                    />
                    <GridColumn
                        {...columnProps("firstName", dataState)}
                        field="firstName"
                        title="First Name"
                        width={"240px"}
                    />
                    <GridColumn
                        {...columnProps("lastName", dataState)}
                        field="lastName"
                        title="Last Name"
                        width={"240px"}
                    />
                    <GridColumn
                        {...columnProps("emailAddress", dataState)}
                        field="emailAddress"
                        title="Email"
                        width={"460px"}
                        cell={props => <EmailLinkCell {...props} />}
                    />
                    <GridColumn
                        {...columnProps("appRole", dataState)}
                        field="appRole"
                        title="Role"
                        width="300px"
                        cell={props => <AppRoleCell {...props} />}
                    />
                    <GridColumn
                        {...columnProps("externalUserState", dataState)}
                        field="externalUserState"
                        title="Invitation"
                        width="240px"
                    />
                    <GridColumn
                        {...columnProps("accountEnabled", dataState)}
                        field="accountEnabled"
                        title="Status"
                        columnMenu={props => <GridColumnMenuCheckboxFilter {...props} data={users} expanded={true} />}
                    />
                </Grid>
            </div>
            <AddEditUser />
        </>
    )
}

export default AppUsers
